import React from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import style from './style.module.less'

export default () => {
  return (
    <HeaderView contentStyle={{ padding: 0 }}>
      <div className={style.middle}>
        <div className={style.btn}>
          <a className={style.alink} href="#/localMerchant/serviceAccount" />
        </div>
        <div className={style.p1} />
        <div className={style.p2} />
        <div className={style.p3} />
        <div className={style.p4} />
        <div className={style.p5} />
        <div className={style.p6} />
        <div className={style.p7} />
      </div>
    </HeaderView>
  )
}
